import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoginModal from "./components/Modals/LoginModal";
import VedioModal from "./components/Modals/VedioModal";
import ResponsiveSidebar from "./components/siderbar/ResponsiveSidebar";
import { login } from "./Redux/LoginAction";
import { get_user_info } from "./Redux/userProfileAction";
import { resume_profile_data } from "./Redux/ResumeAction";
import Topbar from "./components/siderbar/Topbar";
import PlayGround from "./components/tabs/PlayGround";
import {
  DropDownValues,
  savedChange,
  SubDropDown,
  universityDropDownList,
} from "./constant/commonUtils";
import commonApi from "./CommonApi/CommonServices";
import { successMessage } from "./Errors/Toast";
import { scroll_action } from "./Redux/ScrollableAction";
import VerifyEmailModal from "./components/Modals/VerifyEmailModal";
import { user_profile_info } from "./Redux/ProfileAction";

const GetStartedLandingPage = () => {
  const location = useLocation();
  const [dropdownId, setdropdownId] = useState(
    location.pathname === "/universities"
      ? universityDropDownList[0].id
      : DropDownValues[0].id
  );
  const [subId, setSubId] = useState(SubDropDown[0].id);
  const [searchQuery, setSearchQuery] = useState("");
  const [questions, setQuestions] = useState([]);
  const [savedQuestions, setSavedQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [tabtype, setTabtype] = useState("discovered");
  const [loggedInUser, setLoggedInUser] = useState({});
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [showSpinner, setShowSpinner] = useState(true);
  const [menuToggle, setMenuToggle] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [autoStart, setAutoStart] = useState(false);
  const adminSelector = useSelector((state) => state.rootReducer);
  const tokenSelector = useSelector((state) => state.rootReducer?.user?.token);
  const [showModal, setShowModal] = useState("showVideo");
  const navigate = useNavigate();
  const pathParts = location.pathname.split("/").filter(Boolean);
  const [timer, setTimer] = useState(60);
  const [startTimer, setStartTimer] = useState(false);

  useEffect(() => {
    let interval = null;

    if (startTimer && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [startTimer, timer]);

  const openModal = (shouldAutoStart = false) => {
    setAutoStart(shouldAutoStart);

    // Only start timer if it's supposed to and hasn't already started
    if (shouldAutoStart && !startTimer) {
      setStartTimer(true);
    }

    setShowModal("showVerification");
  };

  let route, paymentId;
  if (pathParts.length >= 2 && pathParts[0] === "payment") {
    route = pathParts[0]; // 'payment'
    paymentId = pathParts[1]; // 'pi_3PHQGnL5MmXwVUFI0cWm7lZO'
  } else {
    // If the URL structure is not as expected, navigate to a safe default
    route = "";
    paymentId = "";
  }

  const dispatch = useDispatch();
  useEffect(() => {
    setSpinnerLoader(true);
    setSearchQuery("");
  }, [location.pathname, dropdownId, subId, tabtype]);

  useEffect(() => {
    setSearchQuery("");
    setSubId(SubDropDown[0].id);
    setdropdownId(
      location.pathname === "/universities"
        ? universityDropDownList[0].id
        : DropDownValues[0].id
    );
    setTabtype("discovered");
  }, [location.pathname]);

  const selected_questions_listing = () => {
    const formData = new FormData();

    formData.append("category", dropdownId);
    formData.append("subcategory", subId);
    formData.append("search", searchQuery);
    formData.append("label", location.pathname.replace(/\//g, ""));

    commonApi
      .selected_questions(formData, tokenSelector)
      .then((res) => {
        if (res.status === 200 && res.success) {
          setSelectedQuestions(res?.data);
          setSpinnerLoader(false);
        }
      })
      .catch((err) => {
        console.log("Err", err);
        return { type: "error", message: err.message };
      });
  };

  const get_questions = (token) => {
    const formData = new FormData();

    formData.append("cat", dropdownId);
    formData.append("subcat", subId);
    formData.append("search", searchQuery);
    // formData.append("state", location.pathname.replace(/\//g, ""));

    commonApi
      .get_questions(formData, token)
      .then((res) => {
        if (res.status === 200 && res.success) {
          setQuestions(res.questions);
          setSpinnerLoader(false);
        } else {
        }
      })
      .catch((err) => {
        console.log("Err", err);
        return { type: "error", message: err.message };
      });
  };

  const saved_questions_Listing = () => {
    const formData = new FormData();

    formData.append("category", dropdownId);
    formData.append("subcategory", subId);
    formData.append("search", searchQuery);

    commonApi
      .saved_questions(formData, tokenSelector)
      .then((res) => {
        if (res.status === 200) {
          setSavedQuestions(res.data);
          // setSpinnerLoader(false);
        }
      })
      .catch((err) => {
        console.log("Err", err);
        return { type: "error", message: err.message };
      });
  };

  const save_question = (item, type, label) => {
    const formData = new FormData();

    formData.append("question_id", item.id);
    formData.append(
      "label",
      label ? label : location.pathname.replace(/\//g, "")
    );

    commonApi
      .save_question(formData, tokenSelector)
      .then((res) => {
        if (res.status === 200) {
          if (type === "filterItem") {
            saved_questions_Listing();
          } else {
            const savedUnsavedQuestions = savedChange(
              questions,
              item,
              res.is_saved
            );

            setQuestions(savedUnsavedQuestions);
          }

          successMessage(res.message);
        } else {
        }
      })
      .catch((err) => {
        console.log("Err", err);
        return { type: "error", message: err.message };
      });
  };

  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const handleResize = () => {
    setWindowDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const containerRef = useRef();

  useEffect(() => {
    const resetScroll = () => {
      if (tabtype === "discovered" && containerRef.current) {
        containerRef.current.scrollTop = 0;
      } else if (tabtype === "select" && containerRef.current) {
        containerRef.current.scrollTop = 0;
      } else if (tabtype === "saved" && containerRef.current) {
        containerRef.current.scrollTop = 0;
      }
    };

    resetScroll();
    // eslint-disable-next-line
  }, [tabtype, containerRef.current, location.pathname, dropdownId, subId]);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const { scrollHeight, clientHeight } = containerRef.current;
        if (scrollHeight > clientHeight) {
          dispatch(scroll_action(true));
        } else {
          dispatch(scroll_action(false));
        }
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line
  }, []);

  const hideTooltip = () => {
    const popoverElement = document.getElementById("popover-basic");

    if (popoverElement) {
      popoverElement.style.display = "none"; // Reset to default on unmount
    }
  };
  useEffect(() => {
    // Select the main scrollable container by its ID
    const outerMainScrollContainer =
      document.getElementById("outer-main-scroll"); // Your main container id

    // Add the scroll event listener to the main container
    if (outerMainScrollContainer) {
      outerMainScrollContainer.addEventListener("scroll", hideTooltip);
    }

    // Clean up the event listener on unmount
    return () => {
      if (outerMainScrollContainer) {
        outerMainScrollContainer.removeEventListener("scroll", hideTooltip);
      }
    };
  }, []);

  const guest_login = () => {
    commonApi
      .guest_login()
      .then((res) => {
        if (res.status === 200 && res.success) {
          localStorage.setItem("token", res.token);
          localStorage.setItem("user_type", "guest");
          localStorage.setItem("gender", res.gender);
          localStorage.setItem("payment_status", res.payment_status);
          localStorage.setItem("onboarding", res.onboarding);

          dispatch(
            login(
              res.gender,
              "guest",
              res.onboarding,
              res.payment_status,
              res.token
            )
          );
          setLoggedInUser(res);
          dispatch(get_user_info(res.token));
          dispatch(user_profile_info("", res.token));
          dispatch(resume_profile_data("", res.token));
          get_questions(res.token);
          setShowSpinner(false);
          setShowModal("showVideo");
        }
      })

      .catch((err) => {
        console.log("Err", err);
      });
  };

  useEffect(() => {
    guest_login();
  }, []);

  const renderModal = () => {
    if (showModal === "showVideo") {
      return (
        <VedioModal
          show
          setShowModel={() => setShowModal("")}
          backdrop="static"
          keyboard={false}
        />
      );
    }
    if (showModal === "showLoginPage") {
      return (
        <LoginModal
          backdrop="static"
          keyboard={false}
          show
          onHide={(type, data) => {
            if (type === "showVerify") {
              setUserEmail(data.email);
              openModal(true);
            } else if (type === "showLoginVerify") {
              setUserEmail(data.email);
              openModal(false);
            } else {
              setShowModal("");
            }
          }}
        />
      );
    }
    // if (showModal === "showOnboarding") {
    //   return (
    //     <AIModal
    //       backdrop="static"
    //       keyboard={false}
    //       show
    //       userToken={userToken}
    //       onHide={() => {
    //         // dispatch(get_user_info(adminSelector?.user.token));
    //         dispatch(user_profile_info("", adminSelector?.user.token));
    //         dispatch(resume_profile_data("", adminSelector?.user.token));
    //         navigate("/journey");
    //         dispatch(onBoarding());
    //         setShowModal("");
    //       }}
    //     />
    //   );
    // }
    if (showModal === "showVerification") {
      return (
        <VerifyEmailModal
          backdrop="static"
          keyboard={false}
          show
          autoStart={autoStart ? true : false}
          email={userEmail}
          onHide={(type) => {
            setShowModal("");
          }}
          timer={timer}
          setTimer={setTimer}
          startTimer={startTimer}
          setStartTimer={setStartTimer}
        />
      );
    }
    return null;
  };

  const getLOgged = {
    gender: "male",
    user_type: "guest",
  };

  return (
    <>
      {!showSpinner && (
        <>
          <div
            onClick={() => {
              const isGuest = adminSelector?.user?.user_type === "guest";
              if (isGuest) {
                setShowModal("showLoginPage");
              } else if (!adminSelector?.user?.verfied) {
                openModal(false);
              }
            }}
            className={
              location.pathname === "/dashboard"
                ? "main-app-wrapper dashbaord-page"
                : "main-app-wrapper"
            }
            ref={containerRef}
            id="outer-main-scroll"
            style={{
              overflowY: "hidden",
            }}
          >
            <Topbar
              loggedInUser={getLOgged}
              setMenuToggle={setMenuToggle}
              menuToggle={menuToggle}
            />
            <Container
              style={{
                pointerEvents: "none",
              }}
              fluid
              className="pe-0 ps-0"
            >
              <Row
                className="MainCustomRow"
                style={{
                  height: location.pathname === "/voice" && "100dvh",
                }}
              >
                <Col
                  xxl={2}
                  xl={2}
                  lg={2}
                  md={12}
                  sm={12}
                  xs={12}
                  className="sticky-lg-top sticky-md-top sticky-sm-top custom-sticky-side"
                  style={{
                    height:
                      windowDimensions.width === 1024 &&
                      windowDimensions.height === 1366
                        ? "100vh"
                        : "",
                  }}
                >
                  <ResponsiveSidebar
                    loggedInUser={getLOgged}
                    menuToggle={menuToggle}
                    setMenuToggle={setMenuToggle}
                  />
                </Col>
                <Col
                  xxl={10}
                  xl={10}
                  lg={10}
                  md={12}
                  sm={12}
                  xs={12}
                  className="side-main-content"
                  style={{
                    height: "calc(100vh - 80px)",
                    overflowY: "auto",
                  }}
                >
                  <PlayGround
                    heading="Select All Roles and Activities that Apply"
                    para="When a rising senior is applying to colleges or universities, demonstrating a solid record of scholarship is essential. Here's a list of participations and accomplishments that can help bolster their application"
                    title="Title"
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    questions={questions}
                    save_question={save_question}
                    selectedQuestions={selectedQuestions}
                    setQuestions={setQuestions}
                    tabtype={tabtype}
                    setTabtype={setTabtype}
                    spinnerLoader={spinnerLoader}
                    selected_questions_listing={selected_questions_listing}
                    dropdownId={dropdownId}
                    setdropdownId={setdropdownId}
                    savedQuestions={savedQuestions}
                    subId={subId}
                    DropDownValues={DropDownValues}
                    get_questions={get_questions}
                  />
                </Col>
              </Row>
            </Container>
          </div>
          {renderModal()}
        </>
      )}
    </>
  );
};

export default GetStartedLandingPage;
